import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

const Order_section = ({titles,handleClick}) => {
    const [filter,setFilter]=useState(null);
    // const onchange_filter=(){

    // }
    useEffect(()=>{
        handleClick(filter);
    },[filter])
  return (
    <div className='mb-4'>
         <div className='slider-header'>      
        <div class="dropdown-sort">
            <button class="drop_sort" type="button" data-bs-toggle="dropdown" aria-expanded="false">
            <i class="fa-solid fa-arrow-up-wide-short"></i>ترتيب
            <i className="fa-solid fa-chevron-down "></i>
            </button>
            <ul class="dropdown-menu" >
                <li >
                    <a class="dropdown-item" onClick={()=>setFilter('best_seller')}
                    style={{ display:'flex',justifyContent:'flex-start' }}  href="#">
                    <input class="form-check-input ms-2"  type="radio" checked={filter==='best_seller'} />
                        الأكثر مبيعاً
                    </a>                    
                </li>
                <li >
                    <a class="dropdown-item" onClick={()=>setFilter('Highest_rated')}
                     style={{ display:'flex',justifyContent:'flex-start' }}  href="#">
                    <input class="form-check-input ms-2" type="radio"  checked={filter==='Highest_rated'}/>
                        الأعلى تقيماً
                    </a>                    
                </li>
                <li >
                    <a class="dropdown-item" onClick={()=>setFilter('price_desc')}
                     style={{ display:'flex',justifyContent:'flex-start' }}  href="#">
                    <input class="form-check-input ms-2" type="radio"  checked={filter==='price_desc'} />
                        السعر من الأعلى الى الاقل
                    </a>                    
                </li>
                <li >
                    <a class="dropdown-item" onClick={()=>setFilter('price_asc')}
                     style={{ display:'flex',justifyContent:'flex-start' }}  href="#">
                    <input class="form-check-input ms-2" type="radio"   checked={filter==='price_asc'}/>
                        السعر من الأقل الى الأعلى
                    </a>                    
                </li>
            </ul>
</div>
           
            <div className='slider-cat d-flex'>
            {titles.map((title)=>(
                <div className='d-flex'>
                <h3 className=' h1' >{title.name}</h3>    
                </div>
            )
            )}
                
            </div>
            </div>
    </div>
  )
}

export default Order_section